import React, { useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Hammer from "hammerjs";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export const options = {
  //   width: 839,
  plugins: {
    // title: {
    //   display: true,
    //   text: "User Management",
    // },
    zoom: {
      pan: {
        enabled: true,
        mode: "x",
      },
      zoom: {
        limits: {
          y: { min: 0, max: 100 },
          y2: { min: -5, max: 5 },
        },
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },

        mode: "x",
      },
      rangeMin: {
        x: 2,
        y: 1,
      },
      rangeMax: {
        x: 10,
        y: 150,
      },
    },
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      stacked: true,
      maxTicksLimit: 11,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
];

export const data = {
  labels,
  datasets: [
    {
      label: "SMS",
      data: [192, 78, 99, 82, 77, 63, 68, 79, 162, 213, 205],
      backgroundColor: "rgb(0,0,135)",
      stack: "Stack 0",
    },
    {
      label: "Voice",
      data: [24, 12, 11, 19, 15, 9, 5, 16, 29, 37, 42],
      backgroundColor: "rgb(154,208,245)",
      stack: "Stack 1",
    },
  ],
};

export function MultiGraph() {
  const first = useRef(null);

  return (
    <div className="table-responsive">
      <Bar ref={first} options={options} data={data} />
    </div>
  );
}
